import React from 'react';
import { SectionTitle, Paragraph, Divider } from './Shared';
export function SectionBonuses() {
  return <section data-id="element-20">
      <SectionTitle data-id="element-21">
        Free Bonus #1: The 24/7 "VIP Concierge" Dental Hotline, So You Never
        Have To Guess
      </SectionTitle>

      <div className="my-8" data-id="element-22">
        <img src="https://cdn.magicpatterns.com/uploads/gxhSZYd4nnQLA5WwFZ7LrT/hf_20260421_220805_9c96f7e2-af0d-4065-a9dc-91433a59db2a_(1).png" alt="VIP Dental Concierge - 24/7 Access to Real Dentists" className="w-full" data-id="element-23" />
      </div>

      <Paragraph data-id="element-24">
        Most people spend hours on Google or Reddit trying to figure out why
        their teeth hurt, only to be more confused than when they started.
      </Paragraph>

      <Paragraph data-id="element-25">
        And when you finally see a dentist, you get 5 minutes of their time
        before they move to the next room.
      </Paragraph>

      <Paragraph data-id="element-26">
        Because we are sharing this breakthrough with you, we want to take
        things a step further.
      </Paragraph>

      <Paragraph data-id="element-27">
        We want to help you take back control from a dental system that has been
        managing your symptoms and billing you for the privilege.
      </Paragraph>

      <Paragraph data-id="element-28">
        Simply put, we don't want you to just have the 'tools'; we want you to
        have the experts in your pocket at all times.
      </Paragraph>

      <Paragraph data-id="element-29">
        When you start your 90-day reset today, you are getting direct, 24/7
        digital access to two real dentists, who have seen these results
        firsthand.
      </Paragraph>

      <Paragraph data-id="element-30">
        That's right. We are so committed to your '90-Day Reset' that we are
        putting our own time on the line to make sure you succeed.
      </Paragraph>

      <Paragraph data-id="element-31">
        In other words, you'll never have to Google a dental symptom again.
      </Paragraph>

      <Paragraph data-id="element-32">
        However, since we only have two dentists and 24 hours in a day, we are
        only able to offer this for the first 50 people who act.
      </Paragraph>

      <Paragraph data-id="element-33">
        The good news is that if you're reading this section right now, we still
        have a few spots left open, but who knows how long it will last.
      </Paragraph>

      <Paragraph data-id="element-34">Here's just a handful of the</Paragraph>

      <ul className="list-disc pl-6 mb-6 text-gray-800 space-y-4" data-id="element-35">
        <li data-id="element-36">
          <strong data-id="element-37">No Waiting Rooms:</strong> Have a question about a 'zing' you
          felt? Not sure if your gums are healing correctly? Just send a
          message.
        </li>
        <li data-id="element-38">
          <strong data-id="element-39">Zero Judgment:</strong> These aren't 'standard' dentists who
          will tell you everything is fine while you're in pain. They understand
          the structural and biological reality of micro-cracks.
        </li>
        <li data-id="element-40">
          <strong data-id="element-41">24/7 Professional Guidance:</strong> Whether you need help
          'parking' the lozenge or want to know if a specific food is safe for
          your microbiome, you have a direct line to the people who literally
          pioneered this protocol.
        </li>
      </ul>

      <SectionTitle data-id="element-42">
        Free Report #2: The "Microbial Fingerprint" Diet Guide To Eating Your
        Favorite Foods Guilt-Free
      </SectionTitle>

      <div className="my-8" data-id="element-43">
        <img src="https://cdn.magicpatterns.com/uploads/bpSWRc4bdovKJGFRpbGPhu/hf_20260421_084452_4fd46518-5796-49c9-8636-7860ad63c7d2_(1).png" alt="The Microbial Fingerprint Diet Guide digital download" className="w-full" data-id="element-44" />
      </div>

      <Paragraph data-id="element-45">
        Most people think dental health is about what you don't eat (the "No
        Sugar" rule), but the Microbial Fingerprint Diet Guide is about
        strategic chemistry.
      </Paragraph>

      <Paragraph data-id="element-46">
        In fact, I like to think of this as a "cheat code" for daily life.
      </Paragraph>

      <Paragraph data-id="element-47">
        In this free report, you'll discover how to manipulate the pH and the
        population of your micro-cracks in real-time.
      </Paragraph>

      <Paragraph data-id="element-48">
        This way, you can still eat whatever you'd like, free of guilt, and
        without having to worry about damaging your teeth.
      </Paragraph>

      <Paragraph data-id="element-49">
        The secret is a little-known "cheese finish" trick you do after every
        meal, which does two things simultaneously…
      </Paragraph>

      <Paragraph data-id="element-50">
        First, it acts like a "booster shot" for hydroxyapatite, as it dumps a
        massive load of calcium and phosphate right at the surface of your
        teeth, which is exactly what fuels the process of repair.
      </Paragraph>

      <Paragraph data-id="element-51">
        And second, since your mouth becomes acidic after every meal, this
        little-known "cheese finish" trick helps shock your microbiome's
        environment back to one of healthy dominance.
      </Paragraph>

      <Paragraph data-id="element-52">
        In other words, you certainly don't have to live on kale salad for
        healthy teeth.
      </Paragraph>

      <Paragraph data-id="element-53">
        Instead, do this after every meal (yes, even candy), and you'll "cheat"
        the system.
      </Paragraph>

      <Paragraph data-id="element-54">
        While that is the most powerful "hack" in the guide, you'll also
        discover a few other tactical tips you'll certainly want.
      </Paragraph>

      <Paragraph data-id="element-55">
        The reason for this is because there are 3 household foods, which are
        probably in your fridge right now, that are considered "healthy, but are
        actually "stealth bombers" that provide a 4-hour feast for the bad
        bacteria hiding in your micro-cracks.
      </Paragraph>

      <Paragraph data-id="element-56">
        In fact, once you find them in this report, you'll probably be on your
        way to your fridge, then to the trash, in no time.
      </Paragraph>

      <Paragraph data-id="element-57">
        Along with the "stealth bomber" foods, inside this report you'll also
        discover what I like to call "super-fuel" for your good bacteria.
      </Paragraph>

      <Paragraph data-id="element-58">
        These 3 inexpensive snacks, which you can find at any grocery, will feed
        the healthy bacteria in your mouth so they grow faster than the bad
        guys.
      </Paragraph>

      <Paragraph data-id="element-59">
        If you have a "vulnerable" micro-biome, these 3 "super-fuel" snacks are
        especially for you.
      </Paragraph>

      <Paragraph data-id="element-60">
        All this is yours FREE when you lock in your risk-free trial of the Full
        90-Day Reset Kit.
      </Paragraph>

      <SectionTitle data-id="element-61">
        Free Report #3: The '60-Second Emergency Rescue Rinse' for Instant
        Confidence
      </SectionTitle>

      <div className="my-8" data-id="element-62">
        <img src="https://cdn.magicpatterns.com/uploads/czbXmCfCHceSK1fHyqtAU2/hf_20260421_225056_beabf387-37eb-4de3-9047-b5db8af539af_(1).png" alt="The 60-Second Emergency Rescue Rinse for Instant Confidence digital download" className="w-full" data-id="element-63" />
      </div>

      <Paragraph data-id="element-64">
        Most people are accidentally making their breath worse by doing this
        every morning, not knowing it's like a "carpet bomb" for healthy
        bacteria in your mouth.
      </Paragraph>

      <Paragraph data-id="element-65">
        And if you're someone with a "vulnerable" microbiome fingerprint, you
        certainly don't want to make this mistake.
      </Paragraph>

      <Paragraph data-id="element-66">
        But even then, you may be unknowingly doing it as it's so common.
      </Paragraph>

      <Paragraph data-id="element-67">
        Inside this free report, you'll find out exactly what may be "carpet
        bombing" your healthy bacteria…
      </Paragraph>

      <Paragraph data-id="element-68">
        And instead, is keeping the sulfur producing "factories" in your
        micro-cracks working around-the-clock, to produce the very bacteria
        causing your bad breath.
      </Paragraph>

      <Paragraph data-id="element-69">
        Along with that, you'll also learn about the secret "60-second emergency
        rescue rinse".
      </Paragraph>

      <Paragraph data-id="element-70">
        This way, you can go out and socialize as much as you want, without
        second-guessing your breath ever again.
      </Paragraph>

      <Paragraph data-id="element-71">
        In fact, this "rescue rinse" is so powerful that it will give you that
        "fresh from the dentist" feeling of tight, firm gums.
      </Paragraph>

      <Paragraph data-id="element-72">
        So much to the point where people will start noticing your massive boost
        of confidence, just as soon as you walk into any room.
      </Paragraph>

      <Paragraph data-id="element-73">
        All you have to do is add 3 inexpensive kitchen-ingredients into a glass
        of water, which you may already have right now, and simply swish it for
        60 seconds before you leave the house.
      </Paragraph>

      <Paragraph data-id="element-74">
        When you do this, it simply turns off the power to the very "smell
        factories" in your micro-cracks, without harming a single healthy
        bacteria in the process.
      </Paragraph>

      <Paragraph data-id="element-75">
        If you respond today to this special offer, you'll get immediate access
        to this report - for FREE.
      </Paragraph>

      <SectionTitle data-id="element-76">
        Free Report #4: The '10-Second Jaw Reset' To Stop 250lb Sleep-Grinding
      </SectionTitle>

      <div className="my-8" data-id="element-77">
        <img src="https://cdn.magicpatterns.com/uploads/581NNGMyM6UGppvwSBdL9w/hf_20260421_084747_d6216732-1c15-4b8e-92ac-8d8bab9b071b_(1).png" alt="The Night-Guard Hack - 10-Second Jaw Reset digital download" className="w-full" data-id="element-78" />
      </div>

      <Paragraph data-id="element-79">
        According to new research, grinding your teeth is far more common than
        most people realize, and it's often described as a "silent epidemic."
      </Paragraph>

      <Paragraph data-id="element-80">
        In fact, a major 2024 study found the global prevalence of bruxism - or
        involuntary teeth grinding - is approximately 22.22%...
      </Paragraph>

      <Paragraph data-id="element-81">
        That means nearly one in four people are clenching or grinding their
        teeth, without even knowing it.
      </Paragraph>

      <Paragraph data-id="element-82">Here's why this matters for you…</Paragraph>

      <Paragraph data-id="element-83">
        Simply put, grinding your teeth is the ultimate factory for
        'micro-cracks', especially during your sleep…
      </Paragraph>

      <Paragraph data-id="element-84">
        See, during the day, you use about 20–40 lbs of pressure to chew.
      </Paragraph>

      <Paragraph data-id="element-85">
        But when you're asleep and your "safety sensors" are turned off, your
        jaw can exert over 250 pounds of pressure.
      </Paragraph>

      <Paragraph data-id="element-86">
        Because this force is sustained and repetitive, it creates "structural
        fatigue" in the enamel, causing it to snap at the microscopic level.
      </Paragraph>

      <Paragraph data-id="element-87">
        In this free report, The '10-Second Jaw Reset' To Stop 250lb
        Sleep-Grinding, you'll discover how to protect your "at-home" weld,
        ensuring your newly repaired teeth don't snap overnight.
      </Paragraph>

      <Paragraph data-id="element-88">
        And the best part is that it has nothing to do with using a mouthguard.
      </Paragraph>

      <Paragraph data-id="element-89">
        Instead, the secret is a simple "tongue trick" that uses the anatomy of
        your tongue to biologically disable your jaw's ability to clench, almost
        like a natural "internal cushion" for your teeth.
      </Paragraph>

      <Paragraph data-id="element-90">
        Studies also show doing this for just 60 seconds before bed tells your
        brain's "trigeminal nerve" to switch from high-stress mode to rest mode.
      </Paragraph>

      <Paragraph data-id="element-91">
        You'll find all the details inside this fourth gift.
      </Paragraph>

      <Paragraph data-id="element-92">
        It's also yours FREE when you lock in your risk-free trial of the Full
        90-Day Reset Kit.
      </Paragraph>

      <Divider data-id="element-93" />
    </section>;
}